import React from 'react'
import { Badge, Space, TabsProps, Typography } from 'antd'
import { ITask } from '../OrganizationDetails/types'

export enum ESiteTabs {
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
}

// Imagery Feasibility Constants
export const ERROR_DISPLAY_LIMIT = 2
export const ERROR_COLLAPSE_THRESHOLD = 4

// Filter Modal: Resource Version checkbox 
export const VERSION_CHECKBOX_LIMIT = 10

export const IMAGERY_FEASIBILITY_COLUMNS = [
  {
    title: 'Year',
    dataIndex: 'year',
    key: 'year',
    width: 80,
  },
  {
    title: 'Month',
    dataIndex: 'month',
    key: 'month',
    width: 80,
  },
  {
    title: 'First Capture',
    dataIndex: 'firstCapture',
    key: 'firstCapture',
    width: 180,
  },
  {
    title: 'Last Capture',
    dataIndex: 'lastCapture',
    key: 'lastCapture',
    width: 180,
  },
  {
    title: 'Credits (USD)',
    dataIndex: 'credits',
    key: 'credits',
    width: 150,
    render: (credits: number) => credits ? `$${credits}` : '-',
  },
  {
    title: 'Coverage (%)',
    dataIndex: 'coveragePercentage',
    key: 'coveragePercentage',
    width: 120,
    render: (coverage: number | null) => coverage !== null ? `${coverage * 100}%` : '-',
  },
  {
    title: 'Recommended Image ID',
    dataIndex: 'recommendedImageRequestId',
    key: 'recommendedImageRequestId',
    ellipsis: true,
  },
]

export const adminTabs: TabsProps['items'] = [
  {
    key: 'gis',
    label: `GIS`,
  },
  {
    key: 'csm',
    label: `CSM`,
  },
  {
    key: 'eco',
    label: `ECOLOGY`,
  },
  {
    key: 'ds',
    label: `DS`,
  },
  {
    key: 'eng',
    label: `ENGINEERING`,
  },
]

export const userGroupDropdownItems = [
  {
    key: 'all',
    label: `All`,
  },
  {
    key: 'gis',
    label: `GIS`,
  },
  {
    key: 'csm',
    label: `CSM`,
  },
  {
    key: 'eco',
    label: `ECOLOGY`,
  },
  {
    key: 'ds',
    label: `DS`,
  },
  {
    key: 'eng',
    label: `ENGINEERING`,
  },
]

export const groupAdminTabs = (sites: Array<ITask>): TabsProps['items'] => {
  return [
    {
      key: ESiteTabs.UNASSIGNED,
      label: (
        <Space direction="horizontal" size={'middle'}>
          <Typography.Text>{ESiteTabs.UNASSIGNED}</Typography.Text>
          {/* <Badge
            showZero
            color="rgb(45, 183, 245)"
            count={
              (sites ?? []).filter((site) => !Boolean(site.assignedToUser))
                .length
            }
          /> */}
        </Space>
      ),
    },
    {
      key: ESiteTabs.ASSIGNED,
      label: (
        <Space direction="horizontal" size={'middle'}>
          <Typography.Text>{ESiteTabs.ASSIGNED}</Typography.Text>
          {/* <Badge
            showZero
            color="rgb(45, 183, 245)"
            count={
              (sites ?? []).filter((site) => Boolean(site.assignedToUser))
                .length
            }
          /> */}
        </Space>
      ),
    },
  ]
}
